<template>
<div>
  <track-m :speaker-config="speakerConfig" :speaker="speaker" class="display-mobile"></track-m>
  <track-pc :speaker-config="speakerConfig" :speaker="speaker" class="display-pc"></track-pc>
</div>
</template>

<script>
import TrackPc from './track-pc'
import TrackM from './track-m'

export default {
  data () {
    return {
    }
  },
  components: {
    TrackM,
    TrackPc
  },
  props: [
    'speaker-config',
    'speaker',
    'lecture'
  ],
  computed: {},
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass"></style>
